import React, { useState } from 'react';
import { Card, Button } from '../../components/ui';
import Footer from '../../components/layout/Footer';

const PoojaDetailsPage = ({ onNavigate }) => {
  const [selectedOption, setSelectedOption] = useState('online');

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-orange-100">
        <div className="px-4 py-4 flex items-center">
          <button className="mr-4 p-2 hover:bg-orange-50 rounded-full transition-colors">
            <svg className="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-lg font-semibold text-orange-800">Pooja Details</h1>
        </div>
      </header>

      <main className="flex-1 px-4 py-6">
        {/* Pandit Info Card */}
        <Card className="mb-6 bg-white border-orange-100 shadow-lg">
          <Card.Content className="p-6">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-orange-200 rounded-xl flex items-center justify-center">
                <svg className="w-8 h-8 text-orange-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
                </svg>
              </div>
              <div className="flex-1">
                <h2 className="text-xl font-bold text-orange-800">Rudrabhishek</h2>
                <p className="text-orange-600 text-sm mt-1">by Pandit Ji</p>
              </div>
            </div>
          </Card.Content>
        </Card>

        {/* Details Section */}
        <div className="space-y-4 mb-6">
          <div className="bg-white rounded-xl border border-orange-100 p-4">
            <div className="flex items-center justify-between">
              <span className="text-orange-800 font-medium">Benefits</span>
              <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-orange-100 p-4">
            <div className="flex items-center justify-between">
              <span className="text-orange-800 font-medium">Duration</span>
              <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-orange-100 p-4">
            <div className="flex items-center justify-between">
              <span className="text-orange-800 font-medium">Items required</span>
              <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </div>

        {/* Price Section */}
        <Card className="mb-6 bg-white border-orange-100">
          <Card.Content className="p-4">
            <h3 className="text-lg font-semibold text-orange-800 mb-4">Price</h3>
            <div className="flex items-center justify-between mb-4">
              <span className="text-2xl font-bold text-orange-600">₹ XXXX</span>
              <span className="text-sm bg-orange-100 text-orange-700 px-3 py-1 rounded-full">Online/Offline</span>
            </div>
            
            {/* Service Type Selection */}
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-orange-800 font-medium">With Saraagi</span>
                <div className="flex space-x-2">
                  <button 
                    onClick={() => setSelectedOption('with')}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                      selectedOption === 'with' 
                        ? 'bg-orange-500 text-white' 
                        : 'bg-orange-100 text-orange-700 hover:bg-orange-200'
                    }`}
                  >
                    With
                  </button>
                  <button 
                    onClick={() => setSelectedOption('without')}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                      selectedOption === 'without' 
                        ? 'bg-orange-500 text-white' 
                        : 'bg-orange-100 text-orange-700 hover:bg-orange-200'
                    }`}
                  >
                    Without
                  </button>
                </div>
              </div>
            </div>
          </Card.Content>
        </Card>

        {/* Book Now Button */}
        <Button className="w-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white py-4 rounded-xl font-semibold shadow-lg transform hover:scale-105 transition-all duration-200">
          Add to My Booking
        </Button>
      </main>

      {/* Footer */}
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

export default PoojaDetailsPage;

